import React, { useEffect } from 'react';
import CustomHead from '@/components/Common/Layout/Head';
import PlatformHeader from '@/components/Platform/PlatformHeader';
import PlatformPage from '@/components/Platform';
import {
  AFFILIATE_MARKETING_CONTENT,
  AFFILIATE_MARKETING_HEADER_CONTENT,
} from '@/shared/constants/platform-pages-constants';
import { Layout } from '@/components/Common';
import { NextPageWithLayout } from '@/pages/_app';
import { SEO_META } from '@/shared/seo';
import { SEO_META_PAGES } from '@/shared/types/seo';
import { STATIC_FILE_URL, WEBSITE_URL } from '@/shared/constants';
import { logPageView } from '@/lib/service';
import './index.less';

const AffiliateMarketingPage: NextPageWithLayout<any> = ({}) => {
  useEffect(() => {
    logPageView({
      pageUrl: window.location.href || '',
      routeName: window.location.pathname,
      pageTitle: 'Affiliate Marketing | Pietra',
    });
  }, []);

  return (
    <>
      <PlatformHeader content={AFFILIATE_MARKETING_HEADER_CONTENT} />
      <PlatformPage content={AFFILIATE_MARKETING_CONTENT} utmSource="affiliate_marketing" />
    </>
  );
};

AffiliateMarketingPage.getLayout = (page: React.ReactElement) => {
  return (
    <>
      <CustomHead
        title="Affiliate Marketing | Pietra"
        description="Build a powerful affiliate marketing program to grow sales and track performance and payouts."
        url={`${WEBSITE_URL}/platform/affiliate-marketing`}
        image={`${STATIC_FILE_URL}/79a6e58f8864624f5213a6236a8179f4.png`}
      />
      <Layout
        structured={SEO_META[SEO_META_PAGES.BUSINESS_KIT].jsonld({
          url: typeof window === 'object' ? window.location.href : '',
        })}
      >
        {page}
      </Layout>
    </>
  );
};

export default AffiliateMarketingPage;
